var _a, _b;
import { getPlatform } from "@tencentcloud/universal-api";
const isPC = getPlatform() === "pc";
const isH5 = getPlatform() === "h5";
const isWeChat = getPlatform() === "wechat";
const isApp = getPlatform() === "app";
const isMobile = isH5 || isWeChat || isApp;
const isElectron = ((_a = navigator.userAgent) == null ? void 0 : _a.toLowerCase().indexOf(" electron/")) > -1;
const isWeiXinBrowser = navigator && ((_b = navigator.userAgent) == null ? void 0 : _b.toLocaleLowerCase().indexOf("micromessenger")) > -1;
export {
  isApp,
  isElectron,
  isH5,
  isMobile,
  isPC,
  isWeChat,
  isWeiXinBrowser
};
